import {cn} from "@/lib/utils";

interface IllustratedTitleCardProps {
    title: string;
    description: string;
    imageSrc: string;
    alt: string;
    className?: string;
    width?: number;
    height?: number;
}

export default function IllustratedTitleCard({title, description, imageSrc, alt, className, height, width}: IllustratedTitleCardProps) {
    return (
        <div className={cn("flex flex-col items-center w-full", className)}>
                <img src={imageSrc} alt={alt} width={width ?? 200} height={height ?? 200} className="h-[200px] mb-4" />
            <h2 className="text-3xl text-bleu-marine font-roboto font-bold text-center">{title}</h2>
            <p className="text-xl text-center text-gray-500 font-roboto">{description}</p>
        </div>
    );
}
